/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';

export default class IssueStationDefault extends React.PureComponent {
    render() {
        return (
            <div className="permit-vehicle-wrap">
                <div className="rec-nested-wrap">
                    <div className="rec-grid-12-12">
                        <fieldset>
                            <h2 className="h6">Issuing Station</h2>
                            <p>
                                There is no issuing station for this permit. Permit
                                delivery method is online only, and you will receive an
                                email with more instructions.
                            </p>
                            <p>
                                Station Location:{' '}
                                <span className="font-subtitle">Online only</span>
                            </p>
                        </fieldset>
                    </div>
                </div>
            </div>
        );
    }
}
